import { ExtDate } from '@/helpers/date';

// Rule should be removed in scope of refactoring https://seopa01.atlassian.net/browse/SU-5904

export default {
  params: ['childrenMaxAge'],
  validate: (birthday, { childrenMaxAge }) => {
    return {
      valid: new ExtDate().differenceInYears(birthday) <= childrenMaxAge,
    };
  },
  message: 'The child must be younger than 18 years.',
};
